import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import Listing from './Listing';
import View from './View';

const paths = {
  listing: '/inventory/brands',
  new: '/inventory/brands/new',
  details: '/inventory/brands/:id/details',
  merge: '/inventory/brands/:id/merge',
};

export default [
  <RouteIfRights
    exact
    path={paths.listing}
    key={paths.listing}
    component={Listing}
    rights="manufacturers"
  />,
  <RouteIfRights exact path={paths.new} key={paths.new} component={View} rights="manufacturers" />,
  <RouteIfRights
    exact
    path={paths.details}
    key={paths.details}
    component={View}
    rights="manufacturers"
  />,
  <RouteIfRights
    exact
    path={paths.merge}
    key={paths.merge}
    component={View}
    rights="manufacturers"
  />,
];

export { paths };
